module.exports = __webpack_public_path__ + "img/EP2026.7d90ca7d.svg";